import { IconProps } from '.';

const PercentIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142906)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.16667 5.83333C9.16667 7.67428 7.67428 9.16667 5.83333 9.16667C3.99238 9.16667 2.5 7.67428 2.5 5.83333C2.5 3.99238 3.99238 2.5 5.83333 2.5C7.67428 2.5 9.16667 3.99238 9.16667 5.83333ZM11.6667 5.83333C11.6667 9.05499 9.05499 11.6667 5.83333 11.6667C2.61167 11.6667 0 9.05499 0 5.83333C0 2.61167 2.61167 0 5.83333 0C9.05499 0 11.6667 2.61167 11.6667 5.83333ZM0.78125 27.4495L27.4479 0.782877L29.2157 2.55064L2.54902 29.2173L0.78125 27.4495ZM24.1667 27.5C26.0076 27.5 27.5 26.0076 27.5 24.1667C27.5 22.3257 26.0076 20.8333 24.1667 20.8333C22.3257 20.8333 20.8333 22.3257 20.8333 24.1667C20.8333 26.0076 22.3257 27.5 24.1667 27.5ZM24.1667 30C27.3883 30 30 27.3883 30 24.1667C30 20.945 27.3883 18.3333 24.1667 18.3333C20.945 18.3333 18.3333 20.945 18.3333 24.1667C18.3333 27.3883 20.945 30 24.1667 30Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142906">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PercentIcon;
